module.exports = "/build/images/GreenButton.svg?740d6b06ea6e9bd5aab880dad7fd1bdb";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/GreenButton.svg
// module id = 2415
// module chunks = 0